import React, { useEffect, useState } from 'react'
import SideBar from '../Components/SideBar';
import Header from '../Components/Header';
import { Button, CircularProgress, FormControl, InputLabel, MenuItem, Select, TextField } from '@mui/material';
import axios from 'axios';
import BASEURL from "../Connection/BASEURL";
import { toast, ToastContainer } from 'react-toastify';
import "react-toastify/dist/ReactToastify.css";

const FeePayment = () => {

    const [refreshData, setrefreshData] = useState(false);
    const [loading, setloading] = useState(false);
    const productListArray = [
        "Adult_Single",
        "Adult_Double",
        "Child_Single",
        "Infant",
        // "Lowering_Device"
    ];

    const OpenClosingArray = [
        "OC_Single",
        "OC_Double"
    ];

    const TaxArray = [
        "nhil_levy",
        "vat"
    ]

    const [onc, setonc] = useState("");
    const [oncSelect, setoncSelect] = useState("");


    const Update_ONC = () => {
        setloading(true);
        const payload = {
            [oncSelect]: onc
        }
        axios.put(`${BASEURL}/onc/${oncSelect}`, payload).then((response) => {
            const data = response.data;
            setloading(false);
            if (data) {
                setonc("");
                toast.success("Fee Added Successfully!!", {
                    position: toast.POSITION.TOP_CENTER,
                    // className:" bg"
                })
                window.location.reload();
                setrefreshData(true);

            }

        }).catch((err) => {
            console.log(err);
            setloading(false);
        })
    }

    const [product, setproduct] = useState("");
    const [productselect, setproductselect] = useState("");
    const [loading2, setloading2] = useState(false);

    const Update_ProductList = () => {
        setloading2(true);
        const payload = {
            [productselect]: product
        }
        axios.put(`${BASEURL}/fee/${productselect}`, payload).then((response) => {
            const data = response.data;
            setloading2(false);
            setrefreshData(true);
            if (data) {
                setonc("");
                toast.success("Fee Added Successfully!!", {
                    position: toast.POSITION.TOP_CENTER,
                    // className:" bg"
                })
                window.location.reload();

            }

        }).catch((err) => {
            console.log(err);
            setloading(false);
        })
    }




    const [all_fees, setall_fees] = useState([]);

    useEffect(() => {
        axios.get(`${BASEURL}/fee/`).then((response) => {
            const data = response.data;
            setall_fees(data);
        }).catch((err) => {
            console.lo(err);
        })

    }, [refreshData]);

    const [get_all_onc, setget_all_onc] = useState([]);
    useEffect(() => {
        axios.get(`${BASEURL}/onc/`).then((response) => {
            const data = response.data;
            setget_all_onc(data);
        }).catch((err) => {
            console.lo(err);
        })

    }, [refreshData]);


    const [Tax, setTax] = useState("");
    const [selectTax, setselectTax] = useState("");
    const [loading5, setloading5] = useState(false);

    // Discount states
    const [discountAmount, setDiscountAmount] = useState("");
    const [loading6, setLoading6] = useState(false);
    const [allDiscounts, setAllDiscounts] = useState([]);
    const [selectedDiscountId, setSelectedDiscountId] = useState("");

    // Maintenance fees states
    const [maintenanceAmount, setMaintenanceAmount] = useState("");
    const [loading7, setLoading7] = useState(false);
    const [allMaintenanceFees, setAllMaintenanceFees] = useState([]);
    const [selectedMaintenanceId, setSelectedMaintenanceId] = useState("");


    const SetTax = () => {
        setloading5(true);
        const payload = {
            [selectTax]: Tax
        }
        axios.put(`${BASEURL}/tax/${selectTax}`, payload).then((response) => {
            const data = response.data;
            setloading5(false);
            if (data) {
                setrefreshData(true);
                setTax("");
                toast.success("Tax Added Successfully!!", {
                    position: toast.POSITION.TOP_CENTER,
                    // className:" bg"
                })
                window.location.reload();

            }

        }).catch((err) => {
            console.log(err);
            setloading5(false);
        })
    }

    const [get_all_tax, setget_all_tax] = useState([]);

    useEffect(() => {
        axios.get(`${BASEURL}/tax/`).then((response) => {
            const data = response.data;
            setget_all_tax(data);
        }).catch((err) => {
            console.lo(err);
        });

    }, [refreshData]);

    // Discount functions
    const AddDiscount = async () => {
        if (!discountAmount) {
            toast.error('Please enter discount amount');
            return;
        }
        
        if (!selectedDiscountId) {
            toast.error('Please select a discount to edit');
            return;
        }
        
        try {
            setLoading6(true);
            const payload = {
                discount_amount: parseFloat(discountAmount),
                createdAt: new Date().toISOString()
            };
            
            const response = await axios.put(`${BASEURL}/discounts/${selectedDiscountId}`, payload);
            
            if (response.data) {
                setDiscountAmount("");
                setSelectedDiscountId("");
                toast.success("Discount Updated Successfully!!", {
                    position: toast.POSITION.TOP_CENTER,
                });
                fetchDiscounts(); // Refresh the list
                setrefreshData(true);
            }
        } catch (error) {
            console.log('Error updating discount:', error);
            toast.error('Failed to update discount');
        } finally {
            setLoading6(false);
        }
    };

    const fetchDiscounts = async () => {
        try {
            const response = await axios.get(`${BASEURL}/discounts`);
            const data = response.data;
            // Add createdAt if not present
            const discountsWithCreatedAt = data.map(discount => ({
                ...discount,
                createdAt: discount.createdAt || new Date().toISOString()
            }));
            setAllDiscounts(discountsWithCreatedAt);
        } catch (error) {
            console.log('Error fetching discounts:', error);
        }
    };

    useEffect(() => {
        fetchDiscounts();
    }, [refreshData]);

    // Maintenance fees functions
    const UpdateMaintenanceFee = async () => {
        if (!maintenanceAmount) {
            toast.error('Please enter maintenance fee amount');
            return;
        }
        
        if (!selectedMaintenanceId) {
            toast.error('Please select a maintenance fee to edit');
            return;
        }
        
        try {
            setLoading7(true);
            const payload = {
                maintainance_fees: parseFloat(maintenanceAmount),
                createdAt: new Date().toISOString()
            };
            
            const response = await axios.put(`${BASEURL}/maintenance-fees/${selectedMaintenanceId}`, payload);
            
            if (response.data) {
                setMaintenanceAmount("");
                setSelectedMaintenanceId("");
                toast.success("Maintenance Fee Updated Successfully!!", {
                    position: toast.POSITION.TOP_CENTER,
                });
                fetchMaintenanceFees(); // Refresh the list
                setrefreshData(true);
            }
        } catch (error) {
            console.log('Error updating maintenance fee:', error);
            toast.error('Failed to update maintenance fee');
        } finally {
            setLoading7(false);
        }
    };

    const fetchMaintenanceFees = async () => {
        try {
            const response = await axios.get(`${BASEURL}/maintenance-fees`);
            const data = response.data;
            // Add createdAt if not present
            const maintenanceFeesWithCreatedAt = data.map(fee => ({
                ...fee,
                createdAt: fee.createdAt || new Date().toISOString()
            }));
            setAllMaintenanceFees(maintenanceFeesWithCreatedAt);
        } catch (error) {
            console.log('Error fetching maintenance fees:', error);
        }
    };

    useEffect(() => {
        fetchMaintenanceFees();
    }, [refreshData]);

    useEffect(() => {
        fetchMaintenanceFees();
    }, []);

    return (
        <>
            <ToastContainer />
            <div className=' grid grid-cols-12'>
                <div className='col-span-2 hidden lg:block'>
                    <SideBar />
                </div>
                <div className=' col-span-12 lg:col-span-10 bg-[#D2D2CF]'>
                    <Header />
                    <div className=" mx-2 lg:mx-8">
                        <div>
                            <h1 className=" text-2xl lg:text-4xl font-bold  text-[#111927] py-2 pt-5">
                                Fee and Tax Setting
                            </h1>
                        </div>
                        <div className=' grid grid-cols-2 lg:grid-cols-5 gap-2 mt-5'>
                            {
                                all_fees.map((list, index) => {
                                    return (
                                        <div key={index} className=' bg-white text-center'>
                                            <div className=' bg-[#083050] text-white'>
                                                <h1> Adult Single</h1>
                                            </div>
                                            <div className=' py-2'>
                                                {list.Adult_Single ? `GHS ${list.Adult_Single.toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}` : 'N/A'}
                                            </div>
                                        </div>
                                    );
                                })
                            }

                            {
                                all_fees.map((list, index) => {
                                    return (
                                        <div key={index} className=' bg-white text-center'>
                                            <div className=' bg-[#083050] text-white'>
                                                <h1> Adult Double</h1>
                                            </div>
                                            <div className=' py-2'>
                                                {list.Adult_Double ? `GHS ${list.Adult_Double.toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}` : 'N/A'}
                                            </div>
                                        </div>
                                    );
                                })
                            }

                            {
                                all_fees.map((list, index) => {
                                    return (
                                        <div key={index} className=' bg-white text-center'>
                                            <div className=' bg-[#083050] text-white'>
                                                <h1>Child Single</h1>
                                            </div>
                                            <div className=' py-2'>
                                                {list.Child_Single ? `GHS ${list.Child_Single.toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}` : 'N/A'}
                                            </div>
                                        </div>
                                    );
                                })
                            }

                            {
                                all_fees.map((list, index) => {
                                    return (
                                        <div key={index} className=' bg-white text-center'>
                                            <div className=' bg-[#083050] text-white'>
                                                <h1>Infant</h1>
                                            </div>
                                            <div className=' py-2'>
                                                {list.Infant ? `GHS ${list.Infant.toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}` : 'N/A'}
                                            </div>
                                        </div>
                                    );
                                })
                            }

                            {/* {
                                all_fees.map((list) => {
                                    return (
                                        <div className=' bg-white text-center'>
                                            <div className=' bg-[#083050] text-white'>
                                                <h1>Lowering Device</h1>
                                            </div>
                                            <div className=' py-2'>
                                                {`GHS ${list.Lowering_Device.toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}`}
                                            </div>
                                        </div>
                                    );
                                })
                            } */}
                            {/* {
                                get_all_onc.map((list) => {
                                    return (
                                        <div className=' bg-white text-center'>
                                            <div className=' bg-[#083050] text-white'>
                                                <h1>OC_Single</h1>
                                            </div>
                                            <div className=' py-2'>
                                                {`GHS ${list.OC_Single.toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}`}
                                            </div>
                                        </div>
                                    );
                                })
                            } */}

                            {/* {
                                get_all_onc.map((list) => {
                                    return (
                                        <div className=' bg-white text-center'>
                                            <div className=' bg-[#083050] text-white'>
                                                <h1>OC Double</h1>
                                            </div>
                                            <div className=' py-2'>
                                                {`GHS ${list.OC_Double.toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}`}
                                            </div>
                                        </div>
                                    );
                                })
                            } */}

                            {
                                get_all_tax.map((list, index) => {
                                    return (
                                        <div key={index} className=' bg-white text-center'>
                                            <div className=' bg-[#083050] text-white'>
                                                <h1>VAT</h1>
                                            </div>
                                            <div className=' py-2'>
                                                {list.vat ? `${list.vat.toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 })} %` : 'N/A'}
                                            </div>
                                        </div>
                                    );
                                })
                            }

                            {
                                get_all_tax.map((list, index) => {
                                    return (
                                        <div key={index} className=' bg-white text-center'>
                                            <div className=' bg-[#083050] text-white'>
                                                <h1>NHIL LEVY</h1>
                                            </div>
                                            <div className=' py-2'>
                                                {list.nhil_levy ? `${list.nhil_levy.toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 })} %` : 'N/A'}
                                            </div>
                                        </div>
                                    );
                                })
                            }

                            {/* Discount Cards */}
                            {
                                allDiscounts.map((discount, index) => {
                                    return (
                                        <div key={index} className=' bg-white text-center'>
                                            <div className=' bg-[#0F1D48] text-white'>
                                                <h1>Discount</h1>
                                            </div>
                                            <div className=' py-2'>
                                                {discount.discount_amount ? `${discount.discount_amount.toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 })} %` : 'N/A'}
                                            </div>
                                            <div className=' text-xs text-gray-500 pb-2'>
                                                {discount.createdAt ? new Date(discount.createdAt).toLocaleDateString() : 'N/A'}
                                            </div>
                                        </div>
                                    );
                                })
                            }

                            {/* Maintenance Fees Cards */}
                            {
                                allMaintenanceFees.map((fee, index) => {
                                    return (
                                        <div key={index} className=' bg-white text-center'>
                                            <div className=' bg-[#083050] text-white'>
                                                <h1>Maintenance Fee</h1>
                                            </div>
                                            <div className=' py-2'>
                                                {fee.maintainance_fees ? `% ${fee.maintainance_fees.toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}` : 'N/A'}
                                            </div>
                                            <div className=' text-xs text-gray-500 pb-2'>
                                                {fee.createdAt ? new Date(fee.createdAt).toLocaleDateString() : 'N/A'}
                                            </div>
                                        </div>
                                    );
                                })
                            }


                        </div>
                        <div className=' grid grid-cols-1 lg:grid-cols-4 pt-8 gap-6'>
                            {/* <div style={{ border: "1px solid #dddddd" }} className=' shadow-md p-4 rounded-[10px]  bg-white'>
                                <h1 className=' text-center'>SET OPEN AND CLOSING FEE</h1>
                                <div className=' space-y-6 px-4 py-4'>
                                    <FormControl fullWidth>
                                        <InputLabel label="Tax Amount" id="demo-simple-select-label">Select Open and Closing</InputLabel>
                                        <Select
                                            value={oncSelect}
                                            onChange={(e) => {
                                                setoncSelect(e.target.value);
                                            }}
                                            labelId="demo-simple-select-label"
                                            name="religion"
                                            label="Select Open and Closing"
                                        >
                                            {OpenClosingArray.map((list) => {
                                                return <MenuItem value={list}>{list}</MenuItem>;
                                            })}
                                        </Select>
                                    </FormControl>
                                    <TextField type="number" value={onc} onChange={(e) => {
                                        setonc(e.target.value);
                                    }} placeholder=' Amount' fullWidth />

                                    {loading ? <Button variant="contained" style={{ width: "100%", backgroundColor: "#0F1D48", color: "white", padding: 14 }}><CircularProgress size={17} style={{ color: "white" }} /></Button>
                                        : <Button disabled={!oncSelect || !onc} onClick={Update_ONC} variant="contained" style={{ width: "100%", backgroundColor: "#0F1D48", color: "white", padding: 14 }}>Submit</Button>}
                                </div>
                            </div> */}
                            <div style={{ border: "1px solid #dddddd" }} className=' shadow-md p-4 rounded-[10px] bg-[white] '>
                                <h1 className=' text-center'>SET PRODUCTS FEES</h1>
                                <div className=' space-y-6 px-4 py-4'>
                                    <FormControl fullWidth>
                                        <InputLabel label="Tax Amount" id="demo-simple-select-label">Select Product</InputLabel>
                                        <Select
                                            value={productselect}
                                            label="Select Product"
                                            onChange={(e) => {
                                                setproductselect(e.target.value);
                                            }}
                                            labelId="demo-simple-select-label"
                                            name="religion"
                                        >
                                            {productListArray.map((list) => {
                                                return <MenuItem value={list}>{list}</MenuItem>;
                                            })}
                                        </Select>
                                    </FormControl>
                                    <TextField value={product} onChange={(e) => {
                                        setproduct(e.target.value)
                                    }} label="Amount" placeholder=' Amount' fullWidth />

                                    {loading2 ? <Button variant="contained" style={{ width: "100%", backgroundColor: "#0F1D48", color: "white", padding: 14 }}><CircularProgress size={17} style={{ color: "white" }} /></Button>
                                        : <Button disabled={!productselect || !product} onClick={Update_ProductList} variant="contained" style={{ width: "100%", backgroundColor: "#0F1D48", color: "white", padding: 14 }}>Submit</Button>}

                                </div>
                            </div>

                            <div style={{ border: "1px solid #dddddd" }} className=' shadow-md p-4 rounded-[10px] bg-[white]'>
                                <h1 className=' text-center'>SET TAXES</h1>
                                <div className=' space-y-6 px-4 py-4'>
                                    <FormControl fullWidth>
                                        <InputLabel label="Select Tax" id="demo-simple-select-label">Select Tax</InputLabel>
                                        <Select
                                            value={selectTax}
                                            onChange={(e) => {
                                                setselectTax(e.target.value);
                                            }}
                                            labelId="demo-simple-select-label"
                                        >
                                            {TaxArray.map((list) => {
                                                return <MenuItem value={list}>{list}</MenuItem>;
                                            })}
                                        </Select>
                                    </FormControl>
                                    <TextField
                                        value={Tax} onChange={(e) => {
                                            setTax(e.target.value)
                                        }}
                                        label="Tax Percentage" placeholder='Tax Percentage' fullWidth />

                                    {loading5 ? <Button variant="contained" style={{ width: "100%", backgroundColor: "#0F1D48", color: "white", padding: 14 }}><CircularProgress size={17} style={{ color: "white" }} /></Button>
                                        : <Button disabled={!Tax || !selectTax} onClick={SetTax} variant="contained" style={{ width: "100%", backgroundColor: "#0F1D48", color: "white", padding: 14 }}>Submit</Button>}

                                </div>
                            </div>

                            <div style={{ border: "1px solid #dddddd" }} className=' shadow-md p-4 rounded-[10px] bg-[white]'>
                                <h1 className=' text-center'>SET OR EDIT DISCOUNT</h1>
                                <div className=' space-y-6 px-4 py-4'>
                                    <FormControl fullWidth>
                                        <InputLabel id="discount-select">Select Discount to Edit</InputLabel>
                                        <Select
                                            value={selectedDiscountId}
                                            onChange={(e) => {
                                                setSelectedDiscountId(e.target.value);
                                                // Auto-fill the discount amount when selecting
                                                const selectedDiscount = allDiscounts.find(d => d.tblid === e.target.value);
                                                if (selectedDiscount) {
                                                    setDiscountAmount(selectedDiscount.discount_amount || "");
                                                }
                                            }}
                                            labelId="discount-select"
                                            label="Select Discount to Edit"
                                        >
                                            {allDiscounts.map((discount) => (
                                                <MenuItem key={discount.tblid} value={discount.tblid}>
                                                    {discount.discount_amount}% - {discount.createdAt ? new Date(discount.createdAt).toLocaleDateString() : 'N/A'}
                                                </MenuItem>
                                            ))}
                                        </Select>
                                    </FormControl>
                                    
                                    <TextField
                                        value={discountAmount} 
                                        onChange={(e) => {
                                            setDiscountAmount(e.target.value)
                                        }}
                                        label="Discount Amount (%)" 
                                        placeholder='Discount Percentage' 
                                        type="number"
                                        fullWidth 
                                    />

                                    {loading6 ? 
                                        <Button variant="contained" style={{ width: "100%", backgroundColor: "#0F1D48", color: "white", padding: 14 }}>
                                            <CircularProgress size={17} style={{ color: "white" }} />
                                        </Button>
                                        : 
                                        <Button 
                                            disabled={!discountAmount || !selectedDiscountId} 
                                            onClick={AddDiscount} 
                                            variant="contained" 
                                            style={{ width: "100%", backgroundColor: "#0F1D48", color: "white", padding: 14 }}
                                        >
                                            Update Discount
                                        </Button>
                                    }
                                </div>
                            </div>

                            <div style={{ border: "1px solid #dddddd" }} className=' shadow-md p-4 rounded-[10px] bg-[white]'>
                                <h1 className=' text-center'>SET OR EDIT MAINTENANCE FEE</h1>
                                <div className=' space-y-6 px-4 py-4'>
                                    <FormControl fullWidth>
                                        <InputLabel id="maintenance-select">Select Maintenance Fee to Edit</InputLabel>
                                        <Select
                                            value={selectedMaintenanceId}
                                            onChange={(e) => {
                                                setSelectedMaintenanceId(e.target.value);
                                                // Auto-fill the maintenance amount when selecting
                                                const selectedFee = allMaintenanceFees.find(f => f.tblid === e.target.value);
                                                if (selectedFee) {
                                                    setMaintenanceAmount(selectedFee.maintainance_fees || "");
                                                }
                                            }}
                                            labelId="maintenance-select"
                                            label="Select Maintenance Fee to Edit"
                                        >
                                            {allMaintenanceFees.map((fee) => (
                                                <MenuItem key={fee.tblid} value={fee.tblid}>
                                                    GHS {fee.maintainance_fees} - {fee.createdAt ? new Date(fee.createdAt).toLocaleDateString() : 'N/A'}
                                                </MenuItem>
                                            ))}
                                        </Select>
                                    </FormControl>
                                    
                                    <TextField
                                        value={maintenanceAmount} 
                                        onChange={(e) => {
                                            setMaintenanceAmount(e.target.value)
                                        }}
                                        label="Maintenance Fee Amount" 
                                        placeholder='Maintenance Fee Amount' 
                                        type="number"
                                        fullWidth 
                                    />

                                    {loading7 ? 
                                        <Button variant="contained" style={{ width: "100%", backgroundColor: "#DC2626", color: "white", padding: 14 }}>
                                            <CircularProgress size={17} style={{ color: "white" }} />
                                        </Button>
                                        : 
                                        <Button 
                                            disabled={!maintenanceAmount || !selectedMaintenanceId} 
                                            onClick={UpdateMaintenanceFee} 
                                            variant="contained" 
                                            style={{ width: "100%", backgroundColor: "#083050", color: "white", padding: 14 }}
                                        >
                                            Update Maintenance Fee
                                        </Button>
                                    }
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </>
    )
}

export default FeePayment;